// Thin Cleanup wrapper around the existing, already-shipped
// HouseholdMergePicker (search → pick destination → review fields →
// merge) — the generalized fix for "this household needs to join an
// existing one, but the destination isn't known yet" (spouse-pass,
// trust-reattach's review branch). Deliberately does NOT reimplement
// HouseholdMergePicker or its merge call — it's already used by
// QuarantineActionBar and HouseholdPage.tsx and stays exactly as-is;
// this just gives Cleanup's DecideRail a way to open it for a single
// known source household (see household-search-merge-predicate.ts).

import { HouseholdMergePicker } from "../components/HouseholdMergePicker";
import type { RecordRef } from "./cleanup-records";

export function CleanupHouseholdSearchMergeOverlay({
  source,
  detectorSlug,
  onClose,
  onMerged,
}: {
  source: RecordRef;
  detectorSlug?: string | undefined;
  onClose: () => void;
  onMerged: () => void;
}) {
  return (
    <HouseholdMergePicker
      quarantinedHouseholdId={source.id}
      quarantinedHouseholdName={source.label || "this household"}
      // Names the queue item this merge came from, not a
      // "recommendation" — the two import-stub review detectors
      // deliberately make none, and the reason text is stamped on real
      // client records where it needs to be true (Grant 2026-09-10).
      defaultReason={`Linked via Cleanup${detectorSlug ? ` — ${detectorSlug}` : ""}`}
      onClose={onClose}
      onMerged={onMerged}
    />
  );
}
